'use client'

import { isEmpty } from 'lodash-es'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

import { TFAQCategory } from '@/entities/support'
import { UserType } from '@/entities/user'
import { MobileLayout, Separator } from '@/shared/ui'

import { useFAQsInfinite } from '../../api/get-faqs-infinite'
import { MobileFAQCategory } from '../category'
import { MobileFAQList } from '../faq-list'
import { MobileNoFAQ } from '../no-faq'
import { MobileSearchResult } from '../search-result'

type Props = {
  categories: TFAQCategory[]
  userType: UserType
  keyword?: string
  category?: string
}

export const MobileContent = ({
  categories,
  userType,
  keyword,
  category,
}: Props) => {
  const { faqs, totalElements, hasNextPage, fetchNextPage } = useFAQsInfinite({
    userType,
    searchParams: { keyword, category },
  })

  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView && hasNextPage) {
      void fetchNextPage()
    }
  }, [inView, hasNextPage, fetchNextPage])

  const hasKeyword = !isEmpty(keyword)
  const hasNoSearchResult = hasKeyword && faqs.length === 0

  return (
    <main className="flex h-0 grow flex-col overflow-y-auto">
      {(() => {
        if (!hasKeyword) {
          return (
            <MobileLayout className="pt-0">
              <MobileFAQCategory categories={categories} />
              <MobileFAQList faqs={faqs} />
              <div ref={ref} aria-hidden="true" />
            </MobileLayout>
          )
        }

        if (hasNoSearchResult) {
          return (
            <>
              <MobileSearchResult
                totalElements={totalElements}
                keyword={keyword}
              />
              <Separator color="light-gray" size="large" />
              <MobileNoFAQ />
            </>
          )
        }

        return (
          <>
            <MobileSearchResult
              keyword={keyword}
              totalElements={totalElements}
            />
            <Separator color="light-gray" size="large" />
            <MobileLayout className="pt-6">
              <MobileFAQList faqs={faqs} />
            </MobileLayout>
            <div ref={ref} aria-hidden="true" />
          </>
        )
      })()}
    </main>
  )
}
